import ResourceModel from "models/convention-api/ResourceModel"

export default class ConventionSessionCount extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/convention_session_counts"

  convention_id!: string
  session_count!: number
}
